import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { scrollToTop } from "../../Global/Scroll"
import { errorMessages } from "../../../Constants/Errors";
import { blog_category_page_labels } from "../../../Constants/Labels";
import { callAPI, useStore, usePage, useUser } from "../../../Utils/utils";
import { item_required_error_message, alert_message_type } from "../../../Constants/Messages";
import Alert from "../../Alert/Alert";
import Message from "../../Message/Message";
import ErrorMessage from "../../Global/ErrorMessage";
import './BlogCategoryAdd.css';

export default function BlogCategoryAdd() {

    const navigate = useNavigate();
    const { store } = useStore();
    const { setPage } = usePage();
    const { user } = useUser();
    const [alert, setAlert] = useState()
    const [config, setConfig] = useState();
    const [errors, setErrors] = useState();
    const [loading, setLoading] = useState(false);
    const [formValues, setformValues] = useState({});
    const [showErrorMessage, setShowErrorMessage] = useState(false);

    useEffect(() => {
        setPage({ isLoading: loading })
    }, [loading, setPage])

    const createBlogCategory = () => {
        setLoading(true);
        scrollToTop()

        var pay_load = {
            "store_id": store?.id,
            "name": formValues?.name?.trim(),
            "status": formValues.status ? formValues.status : 'inactive'
        };

        callAPI('/admin/blog-categories/create', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'token': user?.auth_token
            },
            body: JSON.stringify(pay_load)
        }, navigate, setLoading)
            .then(data => {
                if (data.success === true) {
                    var id = data?.blog_category_id || data?.id;
                    navigate(`/admin/blog-category/edit/${id}`);
                    localStorage.setItem('Message', "Blog category created successfully");
                    setLoading(false);
                } else {
                    setLoading(false);
                    setShowErrorMessage(true);
                    setErrors(data?.errors);
                    setAlert({ text: item_required_error_message, type: alert_message_type?.error })
                }
            });
    }

    const onChangeField = (event) => {
        const { name, value, type, checked } = event.target;
        const fieldValue = type === 'checkbox' ? checked : value;
        setformValues({ ...formValues, [name]: fieldValue });
        setShowErrorMessage(false);
        setErrors([])
    }

    const statusOptions = Object.keys(blog_category_page_labels?.blog_category_add_and_edit_page_status)?.map((name) => {
        const value = blog_category_page_labels?.blog_category_add_and_edit_page_status[name];
        return `${name},${value}`;
    });

    return (
        <React.Fragment>

            {alert?.text ?
                <div className="text-center">
                    <Alert text={alert.text} type={alert.type} setAlert={setAlert} />
                </div>
                : ''}

            <button className="btn btn-primary saveButton mb-4" onClick={() => createBlogCategory()}>{blog_category_page_labels?.blog_category_add_page_labels?.btn_label}</button>

            <div className="row">
                <div className="col-lg-8">
                    <div className="card card-default">
                        <div className="card-header card-header-border-bottom">
                            <h2>{blog_category_page_labels?.blog_category_add_page_labels?.title}</h2>
                        </div>
                        <div className="card-body">
                            <div className="ec-store-uploads">
                                <div className="form-group">
                                    <label className="form-label mandatory_field">{blog_category_page_labels?.blog_category_add_and_edit_page_labels?.name}</label>
                                    <input type="text" className="form-control " name="name" maxLength="100" onChange={onChangeField} value={formValues['name'] || ""} />
                                    <div className="errorMessage">
                                        <Message text={errorMessages[ErrorMessage({ fieldName: 'name', errors })]} type={"errorMsg"} showMessage={showErrorMessage} />
                                    </div>
                                </div>
                                <div className="form-group">
                                    <label className="form-label">{blog_category_page_labels?.blog_category_add_and_edit_page_labels?.status}</label>
                                    <select className="form-control" name="status" value={formValues['status'] || ''} onChange={onChangeField}>
                                       
                                        {statusOptions &&
                                            statusOptions?.map((optionString, index) => {
                                                const [name, value] = optionString.split(',');
                                                return <option value={name} key={index}>{value}</option>;
                                            })
                                        }
                                    </select>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className=" mt-4">
                <button className="btn btn-primary" onClick={() => createBlogCategory()}>{blog_category_page_labels?.blog_category_add_page_labels?.btn_label}</button>
            </div>
        </React.Fragment >
    )
}
